import type { QueryClient } from '@tanstack/react-query';

import { storage, storageKeys } from '@/constants/storage';
import { APPOINTMENT_LOOKUP_QUERY_KEY } from '@/hooks/queries/appointment/useAppointmentLookupQuery';

type GuestSessionQueryClient = Pick<QueryClient, 'removeQueries'>;

export function clearGuestAppointmentSession(
  queryClient: GuestSessionQueryClient,
): void {
  // set('') instead of remove(): MMKV web's remove() never fires listeners, and
  // guestUserInfo gets '{}' because useMMKVObject JSON.parses the value.
  storage.set(storageKeys.appointmentConfirmationCode, '');
  storage.set(storageKeys.customerId, '');
  storage.set(storageKeys.guestUserInfo, JSON.stringify({}));

  // Both feed the /auth layout's hasAppointment guard; the customer-state
  // query also carries an appointment, so removing only the lookup isn't enough.
  queryClient.removeQueries({ queryKey: APPOINTMENT_LOOKUP_QUERY_KEY });
  queryClient.removeQueries({ queryKey: ['customer'] });
}
